/*
 * Copyright (c) 2020. American Express Company
 */

import { RealEstateModel } from 'src/types/real-estate.model';
import BWDataService from './bw-data.service';
import DateUtils from 'src/utils/date';
import MixpanelService from './mixpanel.service';

export default class RealEstateService extends BWDataService {
    public static async createRealEstate(realEstateToBeCreated: RealEstateModel): Promise<RealEstateModel> {
        const payload: RealEstateModel = { ...realEstateToBeCreated };
        const newRealEstate = await this.post('/investmentrealestate', payload);
        newRealEstate.mortgageDate = DateUtils.dateify(realEstateToBeCreated.mortgageDate);

        MixpanelService.track('Add Asset', {
            Type: 'real_estate'
        });

        return newRealEstate;
    }

    public static async getRealEstate(): Promise<RealEstateModel[]> {
        const realEstate: RealEstateModel[] = await this.get('/investmentrealestates');
        realEstate?.forEach((re) => {
            re.mortgageDate = DateUtils.dateify(re.mortgageDate);
        });
        return realEstate;
    }

    public static async deleteRealEstate(realEstate: RealEstateModel): Promise<number> {
        return await this.delete(`/investmentrealestate/${realEstate.id}`);
    }

    public static async updateRealEstate(realEstate: RealEstateModel): Promise<RealEstateModel> {
        const payload: RealEstateModel = {
            address: realEstate.address,
            amount: realEstate.amount,
            interest: 0,
            mortgageType: realEstate.mortgageType,
            mortgageAmount: realEstate.mortgageAmount || 0,
            mortgageDate: realEstate.mortgageDate,
            mortgageInterest: realEstate.mortgageInterest || 0,
            mortgagePayment: realEstate.mortgagePayment || 0
        };

        const changeRealEstate = await this.put(`/investmentrealestate/${realEstate.id}`, payload);
        changeRealEstate.mortgageDate = DateUtils.dateify(changeRealEstate.mortgageDate);
        return changeRealEstate;
    }
}
